<!--
	MyResourcesBanner.svelte
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftCircle } from '@mdi/js';
    import { pop } from 'svelte-spa-router';

    const SVG_MOLECULE_PATH = '/img/molecular_ruby.svg';

    onMount(() => {
    })

</script>

<style>
    .my-resources-banner {
        width: fit-content;
        padding: 10px 1% 10px 0%;
        margin: 0px 0px;
        color: var(--tcui-secondary);
    }

    .back-icon {
        width: 36px;
        height: 36px;
    }

    .back-icon:hover {
        /* transform: scale(1.2); */
    }

    :global(.my-resources-banner .back-icon svg) {
        fill: var(--tcui-secondary);
        transition: all .2s;
    }

    :global(.my-resources-banner.back-icon svg:hover) {
        fill: var(--tcui-primary);
        /* transform: scale(1.1); */
    }

    .banner-title {
        margin: 0px 15px;
        font-size: 32px;
        /* font-weight: 400; */
    }

    .banner-icon {
        width: 50px;
        height: 50px;
    }

    .banner-icon img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="my-resources-banner flex-row jc-start">
    <div class="back-icon" on:click={() => pop()}>
        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowLeftCircle} /></Icon>	
    </div>
    <div class="banner-title">My Resources</div>
    <div class="banner-icon">
        <img src={SVG_MOLECULE_PATH} alt={"SVG Design"} draggable="false" >
    </div>

</div>
